import React from 'react';

export const PinSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 72 55" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M35.9248 0C44.0742 0.000129287 50.6825 6.60214 50.6826 14.7432C50.6826 22.1776 42.7566 33.4188 38.5215 38.8965V36.0293C39.5653 34.6222 40.726 32.9983 41.8799 31.252C46.5048 24.251 48.9502 18.5436 48.9502 14.7432C48.9501 7.86049 43.5731 2.2072 36.792 1.75977V12.3564L38.0654 14.1338V26.7441H37.3271V29.917L36.792 31.001V31.9609L38.1416 32.5244V34.126H36.792V40.6494H36.7861V41.0801C36.2527 41.733 35.9339 42.1079 35.9219 42.1221C35.9219 42.1221 21.1631 24.8851 21.1631 14.7432C21.1632 7.48783 26.4136 1.45741 33.3242 0.232422V1.98828C27.3819 3.1913 22.8955 8.45224 22.8955 14.7402C22.8955 18.5407 25.3416 24.2512 29.9697 31.249C31.8182 34.0456 33.6824 36.5338 35.0596 38.2969V21.1387C33.9164 21.3318 32.6267 21.857 31.0762 22.7559L30.5986 23.0322L30.5957 23.0352L27.5234 20.877L28.498 20.1641C30.6266 18.6094 32.8778 17.6704 35.0566 17.416V16.7246L30.5791 15.123L31.834 12.2871L34.3936 13.207L31.6797 4.29395H35.0596V0.0283203C35.3457 0.00947502 35.6355 0 35.9248 0Z"
      fill="#F54900"
    />
    <path d="M46.9961 38.6797H45.8516V42H45.1289V38.6797H44V38H46.9961V38.6797Z" fill="#F54900" />
    <path
      d="M49.1631 41.0117L49.9463 38H51V42H50.292V39.1172L49.5547 42H48.7725L48.0498 39.1172V42H47.3574V38H48.4258L49.1631 41.0117Z"
      fill="#F54900"
    />
  </svg>
);

export default PinSvg;
